import React from "react";
import c1 from "../images/lamaanbox1.jpg";
import c2 from "../images/whatwedo.jpeg";
import c3 from "../images/card-3.jpeg";
import "../style/Services.css";

const Services = () => {
  return (
    <section
      className="services"
      id="services"
      style={{
        marginBottom: "15rem",
      }}
    >
      <h4 className="title">Straight Process</h4>
      <div className="heading-box">
        <h1 className="heading">3 Simple Steps to Your Best Smile</h1>
      </div>
      <div className="box-container container">
        <div class="card">
          <div class="card-image">
            <img src={c3} alt="Free doctor consultation" />
          </div>
          <div class="card-content">
            <h3>Smile Consultation</h3>
            <p>
              Meet with a specialist for a free consultation and a professional
              teeth scan at our clinic. Get expert guidance and take the first
              step toward a confident smile.
            </p>
            {/* <a href="#" class="card-button">
              Read More <span>&rarr;</span>
            </a> */}
          </div>
        </div>
        <div class="card">
          <div class="card-image">
            <img src={c2} alt="See smile transformed" />
          </div>
          <div class="card-content">
            <h3>Smile Blueprint</h3>
            <p>
              Our experts carefully analyze your teeth scan to design a
              personalized treatment plan, ensuring the best approach for
              lasting results.
            </p>
            {/* <a href="#" class="card-button">
              Read More <span>&rarr;</span>
            </a> */}
          </div>
        </div>
        <div class="card">
          <div class="card-image">
            <img
              src={c1}
              alt="Get invisible braces"
              width={"100px !important"}
            />
          </div>
          <div class="card-content">
            <h3>Aligner Pickup</h3>
            <p>
              Once your treatment plan is ready, pick up your custom invisible
              aligners from our clinic and begin your transformation with expert
              support every step of the way.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
